import React, { useState } from "react";
import AITutorHeader from "./../../AITutor/header/AITutorHeader";
import AITutorSidebar from "./../../AITutor/sidebar/AITutorSidebar";
import AIChatPage     from "../AIChatInterface/AIChatInterface";
import ContextPanel   from "../ContextPanel/ContextPanel";
import "./TechifyAILayout.css";

/**
 * TechifyAILayout
 * Root layout: Sidebar | (Header / Chat / Composer) | ContextPanel
 */
const TechifyAILayout = () => {
  const [mode,          setMode]          = useState("tutor");
  const [status,        setStatus]        = useState("active");
  const [contextOpen,   setContextOpen]   = useState(false);
  const [contextData,   setContextData]   = useState({
    topic: null, difficulty: null, pct: 0, lastConcept: null, count: 0,
  });

  const handleModeChange = (m) => setMode(m);
  const toggleContext    = () => setContextOpen((p) => !p);

  return (
    <div className={`tcl-root tcl-root--${mode}`}>
      <AITutorSidebar
        mode={mode}
        onNewSession={() => window.location.reload()}
      />

      <div className="tcl-main">
        <AITutorHeader
          mode={mode}
          status={status}
          onModeChange={handleModeChange}
          onToggleContext={toggleContext}
        />

        <div className="tcl-body">
          <AIChatPage
            mode={mode}
            onStatusChange={setStatus}
            onContextUpdate={setContextData}
          />

          {contextOpen && (
            <ContextPanel mode={mode} data={contextData} />
          )}
        </div>
      </div>
    </div>
  );
};

export default TechifyAILayout;